import { useEffect, useState, useCallback } from "react";
import MovieCard from "../components/MovieCard";
import MovieModal from "../components/MovieModal";
import SearchIcon from "../search.svg";

const API_URL = "https://www.omdbapi.com/?apikey=9a93a967";
const trendingTerms = ["Avengers", "Harry Potter", "Batman", "Spiderman"];

const Home = () => {
  const [movies, setMovies] = useState([]);
  const [trendingMovies, setTrendingMovies] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState("trending");

  const [filterYear, setFilterYear] = useState("");
  const [filterType, setFilterType] = useState("");

  const [selectedMovie, setSelectedMovie] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [favorites, setFavorites] = useState(() => {
  const saved = localStorage.getItem("favorites");
  return saved ? JSON.parse(saved) : [];
});

  useEffect(() => {
    const saved = localStorage.getItem("favorites");
    if (saved) setFavorites(JSON.parse(saved));
  }, []);

  useEffect(() => {
    localStorage.setItem("favorites", JSON.stringify(favorites));
  }, [favorites]);

 

  const toggleFavorite = (movie) => {
  const exists = favorites.find((m) => m.imdbID === movie.imdbID);
  let updated;
  if (exists) {
    updated = favorites.filter((m) => m.imdbID !== movie.imdbID);
  } else {
    updated = [...favorites, movie];
  }
  setFavorites(updated);
  localStorage.setItem("favorites", JSON.stringify(updated));
};


  const searchMovies = useCallback(async (title) => {
    if (!title) return;
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}&s=${title}`);
      const data = await response.json();
      setMovies(data.Search || []);
      setMode("search");
    } catch (error) {
      console.error("Error fetching movies:", error);
      setMovies([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchTerm.trim()) {
        searchMovies(searchTerm);
      } else {
        setMode("trending");
      }
    }, 500);
    return () => clearTimeout(delayDebounce);
  }, [searchTerm, searchMovies]);

  const fetchTrending = async () => {
    const results = {};
    for (let term of trendingTerms) {
      const response = await fetch(`${API_URL}&s=${term}`);
      const data = await response.json();
      if (data.Search) results[term] = data.Search.slice(0, 6);
    }
    setTrendingMovies(results);
  };

  useEffect(() => {
    fetchTrending();
  }, []);

  const getFilteredMovies = () => {
    let baseMovies = mode === "search" ? movies : Object.values(trendingMovies).flat();
    let filtered = [...baseMovies];
    if (filterYear) filtered = filtered.filter((m) => m.Year === filterYear);
    if (filterType) filtered = filtered.filter((m) => m.Type === filterType);
    return filtered;
  };

  const clearFilters = () => {
    setFilterYear("");
    setFilterType("");
  };

  return (
    <div className="app">
      <h1>MovieLand</h1>

      <div className="search">
        <input
          placeholder="Search for movies"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <img src={SearchIcon} alt="Search" onClick={() => searchMovies(searchTerm)} />
      </div>

      <div className="filters">
        <select value={filterYear} onChange={(e) => setFilterYear(e.target.value)}>
          <option value="">All Years</option>
          <option value="2023">2023</option>
          <option value="2022">2022</option>
          <option value="2021">2021</option>
          <option value="2020">2020</option>
        </select>

        <select value={filterType} onChange={(e) => setFilterType(e.target.value)}>
          <option value="">All Types</option>
          <option value="movie">Movie</option>
          <option value="series">Series</option>
          <option value="episode">Episode</option>
        </select>

        <button className="clear-btn" onClick={clearFilters}>Clear Filters</button>
      </div>

      {loading ? (
        <div className="loading"><h2>Loading...</h2></div>
      ) : getFilteredMovies()?.length > 0 ? (
        <div className="container">
          {getFilteredMovies().map((movie) => (
            <div key={movie.imdbID} onClick={() => { setSelectedMovie(movie); setShowModal(true); }}>
              <MovieCard movie={movie} />
              <button
                className="fav-btn"
                onClick={(e) => { e.stopPropagation(); toggleFavorite(movie); }}
              >
                {favorites.find((m) => m.imdbID === movie.imdbID) ? "❤️" : "🤍"}
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty"><h2>No movies found</h2></div>
      )}

      {showModal && selectedMovie && (
        <MovieModal movie={selectedMovie} onClose={() => setShowModal(false)} />
      )}
    </div>
  );
};

export default Home;
